import { Page, BasePlanVO } from "@/libs/model/common/index";
/**新建赛事 */
export class GameVO extends BasePlanVO {
  constructor() {
    super();
    this.disciplineList = "";
    this.gameId = "";
    this.generation = "";
    this.scope = "";
    this.tag = "";
    this.type = "";
  }
}
export class GameId {
  constructor() {
    this.gameId = "";
  }
}
export class BatchGameId {
  constructor() {
    this.gameId = [];
  }
}
/**查询赛事列表 */
export class GamePageListVO extends Page {
  constructor() {
    super();
    this.approveStatus = "";
    this.discipline = "";
    this.name = "";
    this.province = "";
    this.tag = "";
    this.type = "";
    this.year = "";
    this.scope = "";
    this.orgId = "";
  }
}
/**新建赛事 */
export class PlanOtherVO {
  constructor() {
    this.countryFunds = "";
    this.funds = "";
    this.name = "";
    this.orgId = "";
    this.otherPlanId = "";
    this.provinceFunds = "";
    this.type = "";
  }
}
export class PlanItemsVO {
  constructor() {
    this.countryFunds = "";
    this.funds = "";
    this.name = "";
    this.orgId = "";
    this.otherPlanId = "";
    this.provinceFunds = "";
    this.type = "";
    this.otherPlanDictItem1Id = "";
    this.otherPlanDictItem2Id = "";
    this.province = "";
    this.city = "";
    this.address = "";
    this.personNum = "";
    this.countryFunds = "";
    this.provinceFunds = "";
    this.contactPerson = "";
    this.contactPhone = "";
    this.mail = "";
  }
}
// 新增体育赛事备案
export class gameFilingVO {
  constructor() {
    this.address = ""; //详细地址
    this.athleteCount = ""; // 预计参赛运动员
    this.beginDateTime = ""; //开始时间
    this.placeType = "INTERNAL"; // 比赛地点类型
    this.city = ""; // 比赛地点城市
    this.contactPerson = ""; // 联系人
    this.contactPhone = ""; // 联系电话
    this.endDateTime = ""; // 结束时间

    this.hostUnit = ""; // 主办单位
    this.name = ""; // 赛事名称
    this.networkRelay = ""; // 是否有网络转播
    this.networkRelayName = ""; // 网络转播名称
    this.openToViewer = ""; // 是否对观众开放
    this.orgId = ""; // 所属单位
    this.province = ""; // 比赛地点省份
    this.supportUnit = ""; // 协办单位
    this.tvRelay = ""; // 是否有电视转播
    this.tvRelayName = ""; // 电视转播名称
    this.underTakeUnit = ""; // 承办单位
    this.viewerCount = ""; // 开放人数
    this.year = ""; // 年
    this.fundResources = ""; // 经费来源
    this.useFundAmount = ""; // 使用金额
    this.useCenterFund = false; // 是否使用青少年推广与提升经费
    this.hasSafetyPlan = false; // 是否制定赛事安全风险防控方案
  }
}
/**查询分页列表 -  赛事备案 */
export class gameFilingPageListVO extends Page {
  constructor() {
    super();
    this.approveStatus = "";
    this.name = "";
    this.year = "";
    this.orgId = "";
    this.province = "";
  }
}
/**查询分页列表 - 所有登录用户 */
export class PlanOtherPageListVO extends Page {
  constructor() {
    super();
    this.approveStatus = "";
    this.name = "";
    this.type = "";
    this.year = "";
    this.orgId = "";
  }
}

/**获取类型计划需要用到的字典数据 - 所有登录用户 */
export class PlanOtherItemDictVO {
  constructor() {
    this.itemIndex = "";
    this.orgId = "";
    this.otherPlanDictId = "";
    this.type = "";
  }
}
//  新增青少年足球
export class PlanOtherItemInsertVO {
  constructor() {
    this.address = "";
    this.city = "";
    this.contactPerson = "";
    this.contactPhone = "";
    this.countryFunds = "";
    this.funds = "";
    this.mail = "";
    this.name = "";
    this.orgId = "";
    this.otherPlanDictItem1Id = "";
    this.otherPlanDictItem2Id = "";
    this.otherPlanId = "";
    this.province = "";
    this.provinceFunds = "";
    this.type = "";
  }
}
